// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3ywQn","topBottomGutter":"Layout_topBottomGutter__KFtOS"};